import { useNavigate, useParams } from "react-router-dom";
import "./EditUniversity.scss";
import { ChangeEvent, useRef, useState, useEffect } from "react";
import {
  ADD_UNIVERSITY_FIELDS,
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  TOAST_ERRORS,
} from "../../../../Utilities/Constants/Constants";
import * as yup from "yup";
import {
  EDIT_UNIVERSITY_ERROR_MESSAGE,
  ERROR_MESSAGES,
  REGEX,
} from "../../../../Utilities/Constants/Validations";
import { Field, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { isValidPhoneNumber } from "libphonenumber-js";
import {
  S3DataGetApi,
  numberOnly,
  numberOnlyWithDecimal,
  uploadFileToS3,
} from "../../../../Services/Helpers/Helper";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import backButton from "../../../../../Assets/schools/back_button.svg";
import eyeIcon from "../../../../Assets/schools/eye.svg";
import uploadFile from "../../../../Assets/schools/upload.svg";
import upload_image from "../../../../../Assets/schools/upload_image.svg";
import close from "../../../../../Assets/schools/close.svg";
import PhoneInput from "react-phone-input-2";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { useSelector } from "react-redux";

const EditUniversity = () => {
  const formikRef = useRef<any>();
  const [validNumber, setValidNumber] = useState(API_RESPONSE.TRUE);
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const [universityDetail, setUniversityDetail] = useState({
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: "",
    [ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE]: "",
    [ADD_UNIVERSITY_FIELDS.LOCATION]: "",
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]: "",
    [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: "",
    [ADD_UNIVERSITY_FIELDS.EMAIL]: "",
    [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: "",
    [ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES]: "",
    [ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED]: "",
    [ADD_UNIVERSITY_FIELDS.TEACHING_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.RESEARCH]: "",
    [ADD_UNIVERSITY_FIELDS.RATING]: "",
    [ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.FACILITIES_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL]: "",
    [ADD_UNIVERSITY_FIELDS.IMPACT_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.OVERALL_RATING]: "",
    [ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS]: "",
    [ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES]: "",
    [ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES]: "",
    // /[ADD_UNIVERSITY_FIELDS.STUDENTS]: "",
    [ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS]: "",
    [ADD_UNIVERSITY_FIELDS.MALE]: NUMBER_CONSTANTS.ZERO,
    [ADD_UNIVERSITY_FIELDS.FEMALE]: NUMBER_CONSTANTS.ZERO,
    [ADD_UNIVERSITY_FIELDS.TRANSGENDER]: NUMBER_CONSTANTS.ZERO,
    [ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS]: "",
  });
  const { id } = useParams();
  useEffect(() => {
    getUniiversityDetail();
  }, []);

  const [universityImages, setUniversityImages]: any = useState([]);

  const navigate = useNavigate();

  /* Getting university detail based on id */
  const getUniiversityDetail = () => {
    axiosInstance
      .get(API_END_POINTS.UNIVERSITY_API + `?${STORAGE_KEYS.ID}=` + id)
      .then((res) => {
        setUniversityValues(res.data.result.data);
        setUniversityImages(res.data.result.data.images);
      });
  };

  /* Updated University API call */
  const updateUniversityDetail = (payload: any) => {
    payload.images = universityImages;
    axiosInstance
      .put(API_END_POINTS.UNIVERSITY_API + `?${STORAGE_KEYS.ID}=` + id, payload)
      .then((res) => {
        if (res.data.status === API_RESPONSE.TRUE) {
          toast.success(res.data.message, TOASTER_CONFIGS);
          navigate(ROUTES.MANAGE_UNIVERSITIES);
        }
      });
  };
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);

  /* University yup validation schema */
  const universityValidationSchema = yup.object({
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.UNIVERSITY_NAME),
    [ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.QUALITY_ASSURANCE),
    [ADD_UNIVERSITY_FIELDS.LOCATION]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.LOCATION_REQUIRED),
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]: yup
      .array()
      .typeError("")
      .min(NUMBER_CONSTANTS.ONE, EDIT_UNIVERSITY_ERROR_MESSAGE.UNIVERSITY_IMAGES),
    [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: yup
      .string()
      .matches(REGEX.URL_VALIDATION, EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_URL)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.WEBSITE_ADDRESS),

    [ADD_UNIVERSITY_FIELDS.PRINCIPAL]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.PRINCIPAL),

    [ADD_UNIVERSITY_FIELDS.EMAIL]: yup
      .string()
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.EMAIL_REQUIRED),
    //   .email(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.INVALID_EMAIL),
    [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: yup
      .string()
      .required(ERROR_MESSAGES.PHONE_NUMBER),
    [ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES]: yup.string(),
    [ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED]: yup
      .string()
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.PROGRAMS_OFFERED),

    [ADD_UNIVERSITY_FIELDS.TEACHING_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.TEACHING_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.EMPLOYABILITY_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.RESEARCH]: yup
      .number()
      // .min(0)
      // .max(5,EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.RESEARCH)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),
    [ADD_UNIVERSITY_FIELDS.RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.INTERNATIONALIZATION_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.FACILITIES_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),,
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.FACILITIES_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      //   .typeError(ADD_UNIVERSITY_FIELDS_ERROR_MESSAGES.ONLY_NUMBERS),
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.PROGRAMME_STRENGTH_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.INCLUSIVENESS_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.ENVIRONMENTAL)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.IMPACT_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.IMPACT_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.OVERALL_RATING]: yup
      .number()
      .min(NUMBER_CONSTANTS.ZERO)
      .max(NUMBER_CONSTANTS.FIVE, EDIT_UNIVERSITY_ERROR_MESSAGE.MAXIMUM_RATING)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.OVERALL_RATING)
      .typeError(EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_FORMAT),

    [ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.NO_OF_STUDENTS),
    [ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.TOTAL_GRADUATES),

    [ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.NO_OF_EMIRATES),

    // [ADD_UNIVERSITY_FIELDS.STUDENTS]: yup
    //   .string()
    //   .required(EDIT_UNIVERSITY_ERROR_MESSAGE.STUDENTS),

    [ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.NO_OF_EXPATS),
    [ADD_UNIVERSITY_FIELDS.MALE]: yup
      .number()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.MALE),
    [ADD_UNIVERSITY_FIELDS.FEMALE]: yup
      .number()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.FEMALE),
    [ADD_UNIVERSITY_FIELDS.TRANSGENDER]: yup
      .number()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.TRANSGENDER),
    [ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.TOTAL_EDUCATORS),
  });

  /* Setting university detail */
  const setUniversityValues = (data: any) => {
    setUniversityDetail({
      [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: data.university_name,
      [ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE]: data.quality_assurance,
      [ADD_UNIVERSITY_FIELDS.LOCATION]: data.address,
      // [ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]: data.images,
      [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: data.web_link,
      [ADD_UNIVERSITY_FIELDS.PRINCIPAL]: data.principal,

      [ADD_UNIVERSITY_FIELDS.EMAIL]: data.email,
      [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: data.phone_number
        ? data.phone_number
        : "",
      [ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES]: "",
      [ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED]: data.programs_offered
        ? data.programs_offered
        : "",
      [ADD_UNIVERSITY_FIELDS.TEACHING_RATING]: data.teaching_rating
        ? data.teaching_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING]: data.employability_rating
        ? data.employability_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.RESEARCH]: data.research ? data.research : "",
      [ADD_UNIVERSITY_FIELDS.RATING]: data.rating ? data.rating : "",
      [ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING]:
        data.international_rating ? data.international_rating : "",
      [ADD_UNIVERSITY_FIELDS.FACILITIES_RATING]: data.facility_rating
        ? data.facility_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING]:
        data.programme_strength_rating ? data.programme_strength_rating : "",
      [ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING]: data.inclusiveness_rating
        ? data.inclusiveness_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL]: data.environmental
        ? data.environmental
        : "",
      [ADD_UNIVERSITY_FIELDS.IMPACT_RATING]: data.impact_rating
        ? data.impact_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.OVERALL_RATING]: data.overall_rating
        ? data.overall_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS]: data.students_count
        ? data.students_count
        : "",
      [ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES]: data.total_graduates
        ? data.total_graduates
        : "",
      [ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES]: data.emirates_count
        ? data.emirates_count
        : "",
      // [ADD_UNIVERSITY_FIELDS.STUDENTS]: data.student_percentage
      //   ? data.student_percentage
      //   : "",
      [ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS]: data.expats_percentage
        ? data.expats_percentage
        : "",
      [ADD_UNIVERSITY_FIELDS.MALE]: data.male,
      [ADD_UNIVERSITY_FIELDS.FEMALE]: data.female,
      [ADD_UNIVERSITY_FIELDS.TRANSGENDER]: data.transgender,
      [ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS]: data.total_educators
        ? data.total_educators
        : "",
    });
  };

  const uploadUniversityImages = useRef<HTMLInputElement | null>(API_RESPONSE.NULL);

  const ratingRestriction = (event: any) => {
    const enteredValue = event.target.value + event.data; // Combine the current value with the new input
    const parsedValue = parseFloat(enteredValue); // Convert the combined value to a number

    if (parsedValue > NUMBER_CONSTANTS.FIVE) {
      event.preventDefault();
    } else {
      numberOnlyWithDecimal(event);
    }
  };

  useEffect(() => {
    formikRef.current.setFieldValue(
      ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES,
      universityImages
    );
  }, [universityImages]);

  const handleChange = async (event: any) => {
    try {
      if (universityImages.length + event.target.files.length <= NUMBER_CONSTANTS.TEN) {
        for (let i = NUMBER_CONSTANTS.ZERO; i < event.target.files.length; i++) {
          const uploadedImage = await S3DataGetApi(event);
          // schoolImages.length <=5  ?
          setTimeout(() => {
            setUniversityImages((schoolImages: any) => [
              ...schoolImages,
              uploadedImage,
            ]);
          }, NUMBER_CONSTANTS.ZERO);
        }
      } else {
        toast.error(TOAST_ERRORS.IMAGES_LIMIT);
      }
    } catch (error) {
      toast.error(`${TOAST_ERRORS.IMAGE_UPLOAD_ERROR}` + `${error}`);
    }

    // }
  };

  /* Delete tag from taglist */
  const handleDelete = (i: any) => () => {
    setUniversityImages(
      universityImages.filter((item: any, index: any) => index !== i)
    );
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={universityDetail}
        validationSchema={universityValidationSchema}
        onSubmit={(values, actions) => {
          updateUniversityDetail(values);
        }}
        enableReinitialize={true}
      >
        {(formik) => (
          <div className="school_fields_container">
            <div className="arrow-wrap">
              <img
                className="school-back"
                onClick={() => {
                  navigate(ROUTES.MANAGE_UNIVERSITIES);
                }}
                src={backButton}
                alt="Learn and Play"
              />
              <h5 className="name-title">{t("Edit University")}</h5>
            </div>
            <div className="row school-row-wrap">
              <div id="card-title">{t("Basic Details")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("University Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("University Name")}
                      name={ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Location")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Location")}
                      name={ADD_UNIVERSITY_FIELDS.LOCATION}
                      onKeyPress={(event: any) => {
                        //  validateEnglish(event)
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.LOCATION] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.LOCATION] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.LOCATION]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Principal's Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Principal")}
                      name={ADD_UNIVERSITY_FIELDS.PRINCIPAL}
                      onKeyPress={(event: any) => {
                        //  validateEnglish(event)
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.PRINCIPAL] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.PRINCIPAL] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.PRINCIPAL]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Email")}</label>
                    <Field
                      className="form_inputs disabled-input"
                      disabled
                      placeholder={t("Email")}
                      name={ADD_UNIVERSITY_FIELDS.EMAIL}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.EMAIL] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.EMAIL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.EMAIL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Phone Number")}</label>
                    <PhoneInput
                      inputProps={{
                        className: "",
                        name: `${ADD_UNIVERSITY_FIELDS.PHONE_NUMBER}`,
                      }}
                      country={"ae"}
                      enableSearch={true}
                      countryCodeEditable={false}
                      value={formik.values?.phone_number?.toString()}
                      onChange={(e) => {
                        formik.setFieldValue(
                          ADD_UNIVERSITY_FIELDS.PHONE_NUMBER,
                          `+${e}`
                        );
                        setTimeout(() => {
                          formik.validateField(
                            ADD_UNIVERSITY_FIELDS.PHONE_NUMBER
                          );
                          setValidNumber(isValidPhoneNumber(`+${e}`));
                        }, 0);
                      }}
                    />
                    <div className="error-message-wrap">
                      {validNumber === false &&
                        formik.touched[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.INVALID_PHONE_NUMBER
                          )}
                        </div>
                      ) : null}
                      {formik.values[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ==
                        "" &&
                        validNumber === true &&
                        formik.touched[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.PHONE_NUMBER_REQUIRED
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Weblink of University")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Weblink of University")}
                      name={ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Ratings")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Teaching Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Teaching Rating")}
                      name={ADD_UNIVERSITY_FIELDS.TEACHING_RATING}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.TEACHING_RATING] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.TEACHING_RATING] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.TEACHING_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Employability Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Employability Rating")}
                      name={ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING
                      ] &&
                        formik.errors[
                        ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING
                        ] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.EMPLOYABILITY_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Program Strength Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Program Strength Rating")}
                      name={ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING}
                      /*  onKeyPress={(event:any) => {
                        event.target.value<=5 ? numberOnlyWithDecimal(event)   : event.preventDefault()
                      }} */
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING
                      ] &&
                        formik.errors[
                        ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING
                        ] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.PROGRAMME_STRENGTH_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Inclusiveness Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Inclusiveness Rating")}
                      name={ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING
                      ] &&
                        formik.errors[
                        ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING
                        ] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.INCLUSIVENESS_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Impact Rating")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Impact Rating")}
                      name={ADD_UNIVERSITY_FIELDS.IMPACT_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.IMPACT_RATING] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.IMPACT_RATING] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.IMPACT_RATING]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Quality Assurance")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Quality Assurance")}
                      name={ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE
                      ] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.QUALITY_ASSURANCE
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("International Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("International Rating")}
                      name={ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING
                      ] &&
                        formik.errors[
                        ADD_UNIVERSITY_FIELDS.INTERNATIONALIZATION_RATING
                        ] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS
                              .INTERNATIONALIZATION_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Facilities Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Facilities Rating")}
                      name={ADD_UNIVERSITY_FIELDS.FACILITIES_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[
                        ADD_UNIVERSITY_FIELDS.FACILITIES_RATING
                      ] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.FACILITIES_RATING] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.FACILITIES_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Overall Rating")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Overall Rating")}
                      name={ADD_UNIVERSITY_FIELDS.OVERALL_RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.OVERALL_RATING] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.OVERALL_RATING] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.OVERALL_RATING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Environmental")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Environmental")}
                      name={ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.ENVIRONMENTAL]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Other Details")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Number of Students")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Number of Students")}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                      name={ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Total Graduates")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Total Graduates")}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                      name={ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.TOTAL_GRADUATES
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Number of Emirates")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Number of Emirates")}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                      name={ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.NO_OF_EMIRATES
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* <div className="fields_label_wrapper">
                    <label className="fields_label">{t('Students')}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Students")}
                      onInput={numberOnly}
                      name={ADD_UNIVERSITY_FIELDS.STUDENTS}
                    />
                    <div className="error-message-wrap">
                    
                   
                  {formik.touched[ADD_UNIVERSITY_FIELDS.STUDENTS] &&
                  formik.errors[ADD_UNIVERSITY_FIELDS.STUDENTS] ? (
                    <div className="errorMessage">
                      {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.STUDENTS]}`)}
                    </div>
                  ) : null} 
                  </div>
                  </div> */}
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Male")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Male")}
                      name={ADD_UNIVERSITY_FIELDS.MALE}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.MALE] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.MALE] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.MALE]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Female")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Female")}
                      name={ADD_UNIVERSITY_FIELDS.FEMALE}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.FEMALE] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.FEMALE] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.FEMALE]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Others")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Gender")}
                      name={ADD_UNIVERSITY_FIELDS.TRANSGENDER}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.TRANSGENDER] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.TRANSGENDER] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.TRANSGENDER]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Degrees and Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Degrees and Fees")}
                      name={ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Number of Expats")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Number of Expats")}
                      name={ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.NO_OF_EXPATS]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Total Educators")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Total Educators")}
                      name={ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.TOTAL_EDUCATORS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Programms Offered")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Programms Offered")}
                      name={ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Research")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Research")}
                      name={ADD_UNIVERSITY_FIELDS.RESEARCH}
                      onKeyPress={(event: any) => {
                        numberOnly(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.RESEARCH] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.RESEARCH] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.RESEARCH]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Rating")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Rating")}
                      name={ADD_UNIVERSITY_FIELDS.RATING}
                      /* onBeforeInput={(event:any) => {
                        ratingRestriction(event)
                      }} */
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.RATING] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.RATING] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.RATING]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  <div className="fields_label_wrapper">
              <label className="fields_label">{t('Images')}</label>
               <Field
                    className="form_inputs"
                    placeholder={t("Grade Year")}
                    name={ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES}
                  />
              <div className="error-message-wrap">
                    
                   
                  {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] &&
                  formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] ? (
                    <div className="errorMessage">
                      {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]}`)}
                    </div>
                  ) : null} 
                  </div>
            </div> */}

            <div className="row school-row-wrap">
              <div className="col-md-12">
                <div className="fields_label_wrapper">
                  {/* <label className="fields_label">
                    {t("University Images")}
                  </label> */}
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg,.mov,.mp4,.mkv"
                    multiple
                    onChange={handleChange}
                    ref={uploadUniversityImages}
                  />
                  <div className="add_images_wrapper">
                    <div
                      className="add_images_cotainer"
                      onClick={() => uploadUniversityImages.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] &&
                      formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-array-wrap">
                  {universityImages.map((image: any, index: any) => {
                    return (
                      <div className="image-wrap" key={index}>
                        <img
                          src={image}
                          key={index}
                          className="schoolimage-list"
                          alt="Learn and Play"
                        />
                        <img
                          className="cancel-icon"
                          onClick={handleDelete(index)}
                          src={close}
                          alt="Learn and Play"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="actions_button_container">
              <button
                className="cancel_button"
                onClick={() => {
                  navigate("/manage-universities");
                }}
              >
                {t("Cancel")}
              </button>
              <button
                className="update_button"
                type="submit"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                {t("Update")}
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default EditUniversity;
